import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import Header from "../components/header";
import Sider from "antd/es/layout/Sider";
import { Layout } from "antd";
import Menu from "../components/Menu";
import { Content } from "antd/es/layout/layout";
import Chat from "../components/Chat";

const RoutePrivate = ({ sidebar, header, hiddenButtonBack, customContent }) => {
  const { user } = useAuth();

  useEffect(() => {
    let type = "";
    if (user) {
      type = user.type;
    }

    if (!type) {
      window.location.assign("/login");
    }
  }, []);

  let type = "";
  if (user) {
    type = user.type;
  }

  return type ? (
    <Layout>
      {header && <Header sidebar={sidebar || hiddenButtonBack} />}
      <Layout>
        {sidebar && (
          <Sider
            style={{ background: "#008037", minHeight: "calc(100vh - 70px" }}
            width={230}
            trigger={null}
            collapsedWidth={0}
            breakpoint={"xl"}
          >
            <Menu />
          </Sider>
        )}
        <Content className="content" style={customContent || {}}>
          <Outlet />
          {user.type == "cliente" && <Chat />}
        </Content>
      </Layout>
    </Layout>
  ) : (
    <></>
  );
};

export default RoutePrivate;
